import React, { useState } from "react";
import axios from "axios";

const WspolnotaRozliczenieSMS = () => {

  const handleSend = async () => {
    try {
      const response = await axios.post('/api/sms-test', {
        telefon, sms
      })
      console.log(response);
    } catch (error) {
      console.error('Błąd podczas dodawania danych:', error);
    }
};

  const [telefon, setTelefon] = useState("");
  const [sms, setSms] = useState("");

  


  const handleTelefon = e => setTelefon(e.target.value);
  const handleSms = e => setSms( e.target.value);



  return (
    <div className="sms ramka">
      <input 
        value={telefon}
        type="text"
        onChange={handleTelefon}
        placeholder="telefon"
      />
      <input
        value={sms}
        type="text"
        onChange={handleSms}
        placeholder="treść"
      />
      <button
        onClick={handleSend}
      >
        Wyślij
      </button>


    </div>
  )
}

export default WspolnotaRozliczenieSMS;